// src/components/ServicesPage.js
import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { Fade, Zoom } from 'react-awesome-reveal'; // Removed Slide as it was unused
import { 
  FaShoppingCart, FaChartLine, FaMobileAlt, 
  FaCode, FaPaintBrush, FaCogs // Removed unused icons
} from 'react-icons/fa';

const ServicesPage = () => {
  return (
    <div>
      {/* ==================== 1. Page Header (Breadcrumb) ==================== */}
      <section className="py-5 text-center d-flex align-items-center" style={{
        minHeight: '40vh',
        background: 'linear-gradient(rgba(0,0,0,0.8), rgba(0,0,0,0.8)), url("/assets/banner/breadcrumb.jpg") no-repeat center center',
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed'
      }}>
        <Container className="position-relative" style={{ zIndex: 2 }}>
          <Fade triggerOnce direction="down">
            <h1 className="display-4 fw-bold mb-3 text-white">Our Services</h1>
            <p className="lead text-white-50">Home / Services</p>
          </Fade>
        </Container>
      </section>

      {/* ==================== 2. Detailed Services Grid ==================== */}
      <section className="bg-dark">
        <Container>
          <Fade triggerOnce direction="down">
            <span className="text-divider d-block text-center mb-3">What We Offer</span>
            <h2 className="section-title text-center text-white mb-5">
              Services we're offering to <br/>customer to grow business
            </h2>
          </Fade>

          <Row className="justify-content-center g-4">
            {/* Service Card 1 */}
            <Col lg={4} md={6}>
              <Zoom triggerOnce delay={100}>
                <Card className="amiso-card h-100 p-4 text-center">
                  <Card.Body>
                    <FaCode size={55} className="mb-4" />
                    <h5 className="fw-bold text-white mb-2">Custom Web Development</h5>
                    <p className="text-muted small mb-0">Building robust, scalable, and secure web applications tailored to your business needs.</p>
                  </Card.Body>
                </Card>
              </Zoom>
            </Col>

            {/* Service Card 2 */}
            <Col lg={4} md={6}>
              <Zoom triggerOnce delay={200}>
                <Card className="amiso-card h-100 p-4 text-center">
                  <Card.Body>
                    <FaShoppingCart size={55} className="mb-4" />
                    <h5 className="fw-bold text-white mb-2">E-commerce Solutions</h5>
                    <p className="text-muted small mb-0">Creating powerful online stores designed for high conversions and seamless user experience.</p>
                  </Card.Body>
                </Card>
              </Zoom>
            </Col>

            {/* Service Card 3 */}
            <Col lg={4} md={6}>
              <Zoom triggerOnce delay={300}>
                <Card className="amiso-card h-100 p-4 text-center">
                  <Card.Body>
                    <FaChartLine size={55} className="mb-4" />
                    <h5 className="fw-bold text-white mb-2">CRM Solutions</h5>
                    <p className="text-muted small mb-0">Streamline customer relationships, improve engagement, and grow your business efficiently.</p>
                  </Card.Body>
                </Card>
            </Zoom>
            </Col>

            {/* Service Card 4 */}
            <Col lg={4} md={6}>
              <Zoom triggerOnce delay={400}>
                <Card className="amiso-card h-100 p-4 text-center">
                  <Card.Body>
                    <FaPaintBrush size={55} className="mb-4" />
                    <h5 className="fw-bold text-white mb-2">UI/UX Design</h5>
                    <p className="text-muted small mb-0">Crafting intuitive and aesthetically pleasing interfaces that engage users.</p>
                  </Card.Body>
                </Card>
              </Zoom>
            </Col>

            {/* Service Card 5 */}
            <Col lg={4} md={6}>
              <Zoom triggerOnce delay={500}>
                <Card className="amiso-card h-100 p-4 text-center">
                  <Card.Body>
                    <FaMobileAlt size={55} className="mb-4" />
                    <h5 className="fw-bold text-white mb-2">Mobile App Development</h5>
                    <p className="text-muted small mb-0">Developing native and cross-platform mobile applications for iOS and Android.</p>
                  </Card.Body>
                </Card>
              </Zoom>
            </Col>

            {/* Service Card 6 */}
            <Col lg={4} md={6}>
              <Zoom triggerOnce delay={600}>
                <Card className="amiso-card h-100 p-4 text-center">
                  <Card.Body>
                    <FaCogs size={55} className="mb-4" />
                    <h5 className="fw-bold text-white mb-2">Maintenance & Support</h5>
                    <p className="text-muted small mb-0">Ensuring your digital assets run smoothly with ongoing support and updates.</p>
                  </Card.Body>
                </Card>
              </Zoom>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}

export default ServicesPage;